import { useCallback, useEffect, useState } from "react";
import { domain, token } from "../../../../../components/Security";
import axios from "../../../../../api/apiClient";
import loadingSpinner from "../../../../../assets/loading.gif";
import { SetAuditTrail, SetAuditTrailBulk } from "../../../../../components/Reports/AuditTrailReportEmployeeSetup";
import { CreateButton, CreateSearchBarWithPlaceHolder } from "../../../../../components/CommonObjects";

import NoteAddIcon from "@mui/icons-material/NoteAdd";
import SearchIcon from "@mui/icons-material/Search";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import SyncIcon from "@mui/icons-material/Sync";
import { GenerateMessage } from "./GenerateMessage";
import { CreateTable } from "./CreateTable";
import { AddAdjustmentForm } from "./AddAdjustmentForm";
import { EditAdjustmentForm } from "./EditAdjustmentForm";
import { DeleteForm } from "./DeleteForm";
import { DeleteAllForm } from "./DeleteAllForm";
import { EmployeeSelectForm } from "./EmployeeSelectForm";
import { ReferenceSelectForm } from "./ReferenceSelectForm";
import { Button } from "../../../../../common/APICommon";


export function ShowAdjustmentButtons({
	payrollData,
	setPayrollData,
	otherAdditionData,
	otherDeductionData,
	otherAdjustmentData,
	otherLateAdjustmentData,
	setOtherAdditionData,
	setOtherDeductionData,
	setOtherAdjustmentData,
	setOtherLateAdjustmentData,
	filterPayrollPeriodId,
	filterPayTypeId, // no use
	filterClassificationId, // no use
	userAccess,
	type,
	showPostMessage,
	isGenerate,
	isRevert,
	isProcess,
	isPost,
	isUpload,
	setIsUpload,

	loadingOtherAddition,
	loadingOtherDedujction,
	loadingAdjustment,
	loadingLateAdjustment,
	
	filterDataAddition,
	filterDataDeduction,
	filterDataAdjustment,
	filterDataLateAdjustment,
	fetchAdditionData,
	fetchDeductionData,
	fetchAdjustmentData,
	fetchLateAdjustmentData,
	fetchDataProcessedPayroll,
	
	handleGenerateLateApprovedAdjustments,
	openLateAdjustmentForm,
	user,
}) {
	var adjustmentsHeader = ["Id", "Name", "Reason", "Amount", ""];
	var adjustmentsAccesor = [
		"id",
		"employeePersonalInformationFullName",
		"payrollReasonCodeDescription",
		"amount",
		"manage",
	];

  var lateAdjustmentsHeader = ["Id", "Name", "Description", "Amount", ""];
	var lateAdjustmentsAccesor = [
		"id",
		"employeePersonalInformationFullName",
		"description",
		"amount",
		"manage",
	];

	const [currentPage_addition, setCurrentPage_addition] = useState(1);
	const [currentPage_deduction, setCurrentPage_deduction] = useState(1);
	const [currentPage_adjustment, setCurrentPage_adjustment] = useState(1);
	const [currentPage_lateAdjustment, setCurrentPage_lateAdjustment] =
		useState(1);
	const [loadingRequest, setLoadingRequest] = useState(false);
	const [adjustmentType, setAdjustmentType] = useState("OtherAdditionStaging");
	const [activeButton, setActiveButton] = useState("btn-tab-addition");
	//Add
	const [showAddForm, setShowAddForm] = useState(false);
	const [employeePersonalInformationId, setEmployeePersonalInformationId] =
		useState("");
	const [
		employeePersonalInformationFullName,
		setEmployeePersonalInformationFullName,
	] = useState("");
	const [payrollPeriodId, setPayrollPeriodId] = useState("");
	const [payTypeId, setPayTypeId] = useState("");
	const [payrollReasonCodeId, setPayrollReasonCodeId] = useState(null); // change this.
	const [amount, setAmount] = useState("");
	const [noOfHours, setNoOfHours] = useState("");
	const [adjustmentDate, setAdjustmentDate] = useState("");
	const [reference, setReference] = useState(null);
	const [referenceId, setReferenceId] = useState("");
  const [transactionType, setTransactionType] = useState("");
	//Old
	const [
		oldEmployeePersonalInformationId,
		setOldEmployeePersonalInformationId,
	] = useState("");
	const [oldPayrollPeriodId, setOldPayrollPeriodId] = useState("");
	const [oldPayTypeId, setOldPayTypeId] = useState("");
	const [oldPayrollReasonCodeId, setOldPayrollReasonCodeId] = useState("");
	const [oldAmount, setOldAmount] = useState("");
	const [oldAdjustmentDate, setOldAdjustmentDate] = useState("");
	const [oldReferenceId, setOldReferenceId] = useState("");
	//Update
	const [showEditForm, setShowEditForm] = useState(false);
	const [editById, setEditById] = useState("");
	const [dataToEdit, setDataToEdit] = useState([]);
	// Delete
	const [showDeleteForm, setShowDeleteForm] = useState(false);
	const [deleteById, setDeleteById] = useState([]);
	const [deleteData, setDeleteData] = useState([]);
	// Delete All
	const [showDeleteAllForm, setShowDeleteAllForm] = useState(false);
	const [payrollIdForDelete, setPayrollIdForDelete] = useState("");
	const [payTypeIdForDelete, setPayTypeIdForDelete] = useState("");

	const [showEmployeeForm, setShowEmployeeForm] = useState(false);
	const [referenceIdForm, setReferenceIdForm] = useState(false);
	//Request Messages -start
	const [showRequestMessage, setShowRequestMessage] = useState(false);
	const [requestMessage, setRequestMessage] = useState("");
	const [isSuccess, setIsSuccess] = useState("");
	useEffect(() => {
		if (showRequestMessage) {
			const timeoutId = setTimeout(() => {
				setShowRequestMessage(false);
			}, 5000);

			return () => clearTimeout(timeoutId);
		}
	}, [showRequestMessage]);

	const apiUrl = domain + "/api/";

	const handleFilter = (value) => {
		setCurrentPage_addition(1);
		setCurrentPage_deduction(1);
		setCurrentPage_adjustment(1);
		setCurrentPage_lateAdjustment(1);
		const lowercaseValue = value.toLowerCase();
		var res = [];
		if (adjustmentType === "OtherAdditionStaging") {
			res = filterDataAddition.filter((f) =>
				f.employeePersonalInformationFullName
					.toLowerCase()
					.includes(lowercaseValue)
			);

			setOtherAdditionData(res);
		} else if (adjustmentType === "OtherDeductionStaging") {
			res = filterDataDeduction.filter((f) =>
				f.employeePersonalInformationFullName
					.toLowerCase()
					.includes(lowercaseValue)
			);

			setOtherDeductionData(res);
		} else if (adjustmentType === "OtherAdjustmentStaging") {
			res = filterDataAdjustment.filter((f) =>
				f.employeePersonalInformationFullName
					.toLowerCase()
					.includes(lowercaseValue)
			);

			setOtherAdjustmentData(res);
		} else if (adjustmentType === "OtherLateAdjustmentStaging") {
			res = filterDataLateAdjustment.filter((f) =>
				f.employeePersonalInformationFullName
					.toLowerCase()
					.includes(lowercaseValue)
			);

			setOtherLateAdjustmentData(res);
		}
	};
	const handleClick = (id) => {
		setCurrentPage_addition(1);
		setCurrentPage_deduction(1);
		setCurrentPage_adjustment(1);
		setCurrentPage_lateAdjustment(1);
		if (id === "btn-tab-addition") {
			setAdjustmentType("OtherAdditionStaging");
		} else if (id === "btn-tab-deductions") {
			setAdjustmentType("OtherDeductionStaging");
		} else if (id === "btn-tab-adjustments") {
			setAdjustmentType("OtherAdjustmentStaging");
		} else if (id === "btn-tab-late-adjustments") {
			setAdjustmentType("OtherLateAdjustmentStaging");
		}
		setActiveButton(id);
		handleOtherFunction(id);
	};
	const handleOtherFunction = (id) => {
		const additionTable = document.getElementById("addition-table");
		const deductionTable = document.getElementById("deduction-table");
		const adjustmentTable = document.getElementById("adjustment-table");
		const lateAdjustmentTable = document.getElementById(
			"late-adjustment-table"
		);

		switch (id) {
			case "btn-tab-addition":
				additionTable.style.display = "block";
				deductionTable.style.display = "none";
				adjustmentTable.style.display = "none";
				lateAdjustmentTable.style.display = "none";
				break;
			case "btn-tab-deductions":
				additionTable.style.display = "none";
				deductionTable.style.display = "block";
				adjustmentTable.style.display = "none";
				lateAdjustmentTable.style.display = "none";
				break;
			case "btn-tab-adjustments":
				additionTable.style.display = "none";
				deductionTable.style.display = "none";
				adjustmentTable.style.display = "block";
				lateAdjustmentTable.style.display = "none";
				break;
			case "btn-tab-late-adjustments":
				additionTable.style.display = "none";
				deductionTable.style.display = "none";
				adjustmentTable.style.display = "none";
				lateAdjustmentTable.style.display = "block";
				break;
			default:
				break;
		}
	};
	const handleGenerate = useCallback(async () => {
		await fetchAdditionData();
		await fetchDeductionData();
		await fetchAdjustmentData();
		await fetchLateAdjustmentData();
		await fetchDataProcessedPayroll();
	}, [
		fetchAdditionData,
		fetchDeductionData,
		fetchAdjustmentData,
		fetchLateAdjustmentData,
		fetchDataProcessedPayroll,
	]);

	useEffect(() => {
		fetchAdditionData();
		fetchDeductionData();
		fetchAdjustmentData();
		fetchLateAdjustmentData();
		fetchDataProcessedPayroll();
	}, [
		type,
		handleGenerate,
		showPostMessage,
		fetchAdditionData,
		fetchDeductionData,
		fetchAdjustmentData,
		fetchLateAdjustmentData,
		fetchDataProcessedPayroll,
		isGenerate,
		isRevert,
		isProcess,
		isPost,
		isUpload,
	]);
	useEffect(() => {
		if (showEditForm) {
			setEmployeePersonalInformationId(
				dataToEdit.employeePersonalInformationId
			);
			setEmployeePersonalInformationFullName(
				dataToEdit.employeePersonalInformationFullName
			);
			setPayrollPeriodId(dataToEdit.payrollPeriodId);
			setPayTypeId(dataToEdit.payTypeId);
			setPayrollReasonCodeId(dataToEdit.payrollReasonCodeId);
			setAmount(dataToEdit.amount);
			setAdjustmentDate(dataToEdit.adjustmentDate);
			setReferenceId(dataToEdit.referenceId);
      setTransactionType(dataToEdit.transactionType);

			setOldEmployeePersonalInformationId(
				dataToEdit.employeePersonalInformationId
			);
			setOldPayrollPeriodId(dataToEdit.payrollPeriodId);
			setOldPayTypeId(dataToEdit.payTypeId);
			setOldPayrollReasonCodeId(dataToEdit.payrollReasonCodeId);
			setOldAmount(dataToEdit.amount);
			setOldAdjustmentDate(dataToEdit.adjustmentDate);
			setOldReferenceId(dataToEdit.referenceId);
		}
	}, [showEditForm, dataToEdit]);

	const handleSubmit = async (event) => {
		event.preventDefault();

		const data = {
			employeePersonalInformationId: employeePersonalInformationId,
			payrollPeriodId: payrollPeriodId,
			payTypeId: payTypeId,
			payrollReasonCodeId: payrollReasonCodeId,
			amount: amount,
			...((adjustmentType === "OtherAdjustmentStaging" ||
				adjustmentType === "OtherLateAdjustmentStaging") && {
				noOfHours: noOfHours,
			}),
			...((adjustmentType === "OtherAdjustmentStaging" ||
				adjustmentType === "OtherLateAdjustmentStaging") && {
				adjustmentDate: adjustmentDate,
			}),
			...((adjustmentType === "OtherAdjustmentStaging" ||
				adjustmentType === "OtherLateAdjustmentStaging") && {
				referenceId: referenceId ? referenceId : 0,
			}),
			...((adjustmentType === "OtherAdjustmentStaging" ||
				adjustmentType === "OtherLateAdjustmentStaging") && {
				transactionType: reference?.requestTypeId === 1 ? "Leave" : "Overtime",
			}),
			...(adjustmentType === "OtherLateAdjustmentStaging" && {
				isLateAdjustment: true,
        transactionType: reference?.requestTypeId === 1 ? "Leave" : "Overtime",
			}),
		};

		console.log("Final bulkData:", JSON.stringify(data, null, 2));

		// ...(adjustmentType !== "OtherAdjustmentStaging" ? { amount: amount } : {})

		var adjustmentTypeURL = adjustmentType;

		if (
			adjustmentType === "OtherAdjustmentStaging" ||
			adjustmentType === "OtherLateAdjustmentStaging"
		) {
			adjustmentTypeURL = "OtherAdjustmentStaging";
		}

		try {
			setLoadingRequest(true);
			const response = await axios.post(apiUrl + `${adjustmentTypeURL}`, data, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});

			let field = "";

			if (adjustmentType === "OtherAdditionStaging") {
				field = "Other Addition Add";
			} else if (adjustmentType === "OtherDeductionStaging") {
				field = "Other Deduction Add";
			} else if (adjustmentType === "OtherAdjustmentStaging") {
				field = "Other Adjustment Add";
			} else if (adjustmentType === "OtherLateAdjustmentStaging") {
				field = "Other Late Adjustment Add";
			}

			await SetAuditTrail({
				setupArea: "Payroll",
				actionTaken: "insert",
				field: field,
				newValue: `${response.data.payrollReasonCodeId}`,
				oldValue: "-",
				dateSaved: new Date(),
				savedById: user.id,
			});

			await fetchAdditionData();
			await fetchDeductionData();
			await fetchAdjustmentData();
			await fetchLateAdjustmentData();
			await fetchDataProcessedPayroll();

			console.log("Data added successfully");
			setShowRequestMessage(true);
			setIsSuccess(true);

			// Reload table data and reset form fields
			setEmployeePersonalInformationId("");
			setPayrollPeriodId("");
			setPayTypeId("");
			setPayrollReasonCodeId(null);
			setAmount("");
			setAdjustmentDate("");
			setReferenceId("");
			setReference(null);
			setNoOfHours("");
			setShowAddForm(false); // Hide the add form
			// fetchData(adjustmentType);
		} catch (error) {
			console.error("There was a problem adding data:", error);
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error("Error:", error);
			const errorMessage = JSON.parse(
				error.response.request.responseText
			).message;
			setRequestMessage(errorMessage);
		} finally {
			setLoadingRequest(false);
		}

		setShowAddForm(false);
	};
	const handleUpdate = async (event) => {
		event.preventDefault();

		const data = {
			employeePersonalInformationId: employeePersonalInformationId,
			payrollPeriodId: payrollPeriodId,
			payTypeId: payTypeId,
			payrollReasonCodeId: payrollReasonCodeId,
			amount: amount,
			...((adjustmentType === "OtherAdjustmentStaging" ||
				adjustmentType === "OtherLateAdjustmentStaging") && {
				noOfHours: noOfHours,
			}),
			...((adjustmentType === "OtherAdjustmentStaging" ||
				adjustmentType === "OtherLateAdjustmentStaging") && {
				adjustmentDate: adjustmentDate,
			}),
			...((adjustmentType === "OtherAdjustmentStaging" ||
				adjustmentType === "OtherLateAdjustmentStaging") && {
				referenceId: referenceId,
			}),
			...((adjustmentType === "OtherAdjustmentStaging" ||
				adjustmentType === "OtherLateAdjustmentStaging") && {
				transactionType: transactionType ?? (reference?.requestTypeId === 1 ? "Leave" : "Overtime"),
			}),
			...(adjustmentType === "OtherLateAdjustmentStaging" && {
				isLateAdjustment: true,
				transactionType: transactionType ?? (reference?.requestTypeId === 1 ? "Leave" : "Overtime"),
			}),
		};

		var adjustmentTypeURL = adjustmentType;

		if (
			adjustmentType === "OtherAdjustmentStaging" ||
			adjustmentType === "OtherLateAdjustmentStaging"
		) {
			adjustmentTypeURL = "OtherAdjustmentStaging";
		}

		try {

      console.log("Saving.........", {data, reference})
			setLoadingRequest(true);
			await axios.put(apiUrl + `${adjustmentTypeURL}/${editById}`, data, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});
			let field = "";

			if (adjustmentType === "OtherAdditionStaging") {
				field = "Other Addition Update";
			} else if (adjustmentType === "OtherDeductionStaging") {
				field = "Other Deduction Update";
			} else if (adjustmentType === "OtherAdjustmentStaging") {
				field = "Other Adjustment Update";
			} else if (adjustmentType === "OtherLateAdjustmentStaging") {
				field = "Other Late Adjustment Update";
			}

			let auditInfo = [];

			if (
				data.employeePersonalInformationId !== oldEmployeePersonalInformationId
			) {
				auditInfo.push({
					setupArea: "Payroll",
					actionTaken: "update",
					field: field,
					newValue: `${data.employeePersonalInformationId}`,
					oldValue: `${oldEmployeePersonalInformationId}`,
					dateSaved: new Date(),
					savedById: user.id,
				});
			}
			if (data.payrollPeriodId !== oldPayrollPeriodId) {
				auditInfo.push({
					setupArea: "Payroll",
					actionTaken: "update",
					field: field,
					newValue: `${data.payrollPeriodId}`,
					oldValue: `${oldPayrollPeriodId}`,
					dateSaved: new Date(),
					savedById: user.id,
				});
			}
			if (data.payTypeId !== oldPayTypeId) {
				auditInfo.push({
					setupArea: "Payroll",
					actionTaken: "update",
					field: field,
					newValue: `${data.payTypeId}`,
					oldValue: `${oldPayTypeId}`,
					dateSaved: new Date(),
					savedById: user.id,
				});
			}
			if (data.payrollReasonCodeId !== oldPayrollReasonCodeId) {
				auditInfo.push({
					setupArea: "Payroll",
					actionTaken: "update",
					field: field,
					newValue: `${data.payrollReasonCodeId}`,
					oldValue: `${oldPayrollReasonCodeId}`,
					dateSaved: new Date(),
					savedById: user.id,
				});
			}
			if (data.amount !== oldAmount) {
				auditInfo.push({
					setupArea: "Payroll",
					actionTaken: "update",
					field: field,
					newValue: `${data.amount}`,
					oldValue: `${oldAmount}`,
					dateSaved: new Date(),
					savedById: user.id,
				});
			}
			if (data.adjustmentDate !== oldAdjustmentDate) {
				auditInfo.push({
					setupArea: "Payroll",
					actionTaken: "update",
					field: field,
					newValue: `${data.adjustmentDate}`,
					oldValue: `${oldAdjustmentDate}`,
					dateSaved: new Date(),
					savedById: user.id,
				});
			}
			if (data.referenceId !== oldReferenceId) {
				auditInfo.push({
					setupArea: "Payroll",
					actionTaken: "update",
					field: field,
					newValue: `${data.referenceId}`,
					oldValue: `${oldReferenceId}`,
					dateSaved: new Date(),
					savedById: user.id,
				});
			}

			await SetAuditTrailBulk({ data: auditInfo });
			await fetchAdditionData();
			await fetchDeductionData();
			await fetchAdjustmentData();
			await fetchLateAdjustmentData();
			await fetchDataProcessedPayroll();

			console.log("Data added successfully");
			setShowRequestMessage(true);
			setIsSuccess(true);

			// Reload table data and reset form fields
			setEmployeePersonalInformationId("");
			setPayrollPeriodId("");
			setPayTypeId("");
			setPayrollReasonCodeId(null);
			setAmount("");
			setAdjustmentDate("");
			setReferenceId("");
			setReference(null);
			setNoOfHours("");
			setShowEditForm(false); // Hide the add form
			// fetchData(adjustmentType);
		} catch (error) {
			console.error("There was a problem adding data:", error);
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error("Error:", error);
			const errorMessage = JSON.parse(
				error.response.request.responseText
			).message;
			setRequestMessage(errorMessage);
		} finally {
			setLoadingRequest(false);
		}

		setShowEditForm(false);
	};
	const handleDelete = async () => {
		var adjustmentTypeURL = adjustmentType;

		if (
			adjustmentType === "OtherAdjustmentStaging" ||
			adjustmentType === "OtherLateAdjustmentStaging"
		) {
			adjustmentTypeURL = "OtherAdjustmentStaging";
		}

		try {
			setLoadingRequest(true);
			await axios.delete(apiUrl + `${adjustmentTypeURL}/${deleteById}`, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});
			let field = "";

			if (adjustmentType === "OtherAdditionStaging") {
				field = "Other Addition";
			} else if (adjustmentType === "OtherDeductionStaging") {
				field = "Other Deduction";
			} else if (adjustmentType === "OtherAdjustmentStaging") {
				field = "Other Adjustment";
			} else if (adjustmentType === "OtherLateAdjustmentStaging") {
				field = "Other Late Adjustment";
			}

			await SetAuditTrail({
				setupArea: "Payroll",
				actionTaken: "delete",
				field: field,
				newValue: `-`,
				oldValue: `${deleteData.employeePersonalInformationFullName}`,
				dateSaved: new Date(),
				savedById: user.id,
			});
			await fetchAdditionData();
			await fetchDeductionData();
			await fetchAdjustmentData();
			await fetchLateAdjustmentData();
			await fetchDataProcessedPayroll();

			console.log("Deleted successfully");
			setShowRequestMessage(true);
			setIsSuccess(true);

			// Reload table data and reset state
			setShowDeleteForm(false);
			setDeleteById("");
			// fetchData(adjustmentType);
		} catch (error) {
			console.error("There was a problem deleting employee:", error);
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error("Error:", error);
			const errorMessage = JSON.parse(
				error.response.request.responseText
			).message;
			setRequestMessage(errorMessage);
		} finally {
			setLoadingRequest(false);
		}

		setShowDeleteForm(false);
	};
	const handleDeleteAll = async () => {
		if (!payrollIdForDelete) {
			alert("Please select payroll period id");
			return; // Exit early if fields are empty
		}

		var adjustmentTypeURL = adjustmentType;

		if (
			adjustmentType === "OtherAdjustmentStaging" ||
			adjustmentType === "OtherLateAdjustmentStaging"
		) {
			adjustmentTypeURL = "OtherAdjustmentStaging";
		}

		try {
			setLoadingRequest(true);
			await axios.delete(
				apiUrl +
				`${adjustmentTypeURL}/paytype/${payTypeIdForDelete}/payrollperiod/${payrollIdForDelete}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json",
					},
				}
			);
			let field = "";

			if (adjustmentType === "OtherAdditionStaging") {
				field = "Other Addition";
			} else if (adjustmentType === "OtherDeductionStaging") {
				field = "Other Deduction";
			} else if (adjustmentType === "OtherAdjustmentStaging") {
				field = "Other Adjustment";
			} else if (adjustmentType === "OtherLateAdjustmentStaging") {
				field = "Other Late Adjustment";
			}

			await SetAuditTrail({
				setupArea: "Payroll",
				actionTaken: "delete all",
				field: field,
				newValue: `-`,
				oldValue: "-",
				dateSaved: new Date(),
				savedById: user.id,
			});
			await fetchAdditionData();
			await fetchDeductionData();
			await fetchAdjustmentData();
			await fetchLateAdjustmentData();
			await fetchDataProcessedPayroll();

			console.log("Deleted successfully");
			setShowRequestMessage(true);
			setIsSuccess(true);

			// Reload table data and reset state
			setShowDeleteAllForm(false);
			setPayrollIdForDelete("");
			// fetchData(adjustmentType);
		} catch (error) {
			console.error("There was a problem deleting employee:", error);
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error("Error:", error);
			const errorMessage = JSON.parse(
				error.response.request.responseText
			).message;
			setRequestMessage(errorMessage);
		} finally {
			setLoadingRequest(false);
		}

		setShowDeleteAllForm(false);
	};

	const addHandleClick = () => {
		setShowAddForm(true);
	};
	const editHandleClick = (data) => {
		setEditById(data.id);
		setDataToEdit(data);
		setShowEditForm(true);
	};
	const deleteHandleClick = (data) => {
		setShowDeleteForm(true);
		setDeleteById(data.id);
		setDeleteData(data);
	};
	const deleteAllHandleClick = (data) => {
		setShowDeleteAllForm(true);
	};
	const closeAddHandleClick = () => {
		setShowAddForm(false);
	};
	const closeEditHandleClick = () => {
		setShowEditForm(false);
	};
	const closeDeleteHandleClick = () => {
		setShowDeleteForm(false);
	};
	const closeDeleteAllHandleClick = () => {
		setShowDeleteAllForm(false);
	};
	const closeEmployeeForm = () => {
		setShowEmployeeForm(false);
	};
	const closeReferenceIdForm = () => {
		setReferenceIdForm(false);
	};

	return (
		<div>
			<div className="mainte-body-top row">
				{CreateSearchBarWithPlaceHolder(
					"",
					"mainte-search row",
					"mainte-search-icon",
					"mainte-search-input",
					(e) => handleFilter(e.target.value),
					"Search by name",
					SearchIcon
				)}
			</div>
			<div className="payroll-tab-header row">
				<div className="payroll-tab-leftSide row">
					<div className="leftSide-btn">
						<button
							id={activeButton === "btn-tab-addition" ? "btn-tab-active" : ""}
							onClick={() => {
								handleClick("btn-tab-addition");
								handleOtherFunction("btn-tab-addition");
							}}
						>
							OTHER ADDITIONS
						</button>
					</div>
					<div className="leftSide-btn">
						<button
							id={activeButton === "btn-tab-deductions" ? "btn-tab-active" : ""}
							onClick={() => {
								handleClick("btn-tab-deductions");
								handleOtherFunction("btn-tab-deductions");
							}}
						>
							OTHER DEDUCTIONS
						</button>
					</div>
					<div className="leftSide-btn">
						<button
							id={
								activeButton === "btn-tab-adjustments" ? "btn-tab-active" : ""
							}
							onClick={() => {
								handleClick("btn-tab-adjustments");
								handleOtherFunction("btn-tab-adjustments");
							}}
						>
							ADJUSTMENTS
						</button>
					</div>
					{isGenerate && filterPayrollPeriodId && (
						<div className="leftSide-btn">
							<button
								id={
									activeButton === "btn-tab-late-adjustments"
										? "btn-tab-active"
										: ""
								}
								onClick={() => {
									handleClick("btn-tab-late-adjustments");
									handleOtherFunction("btn-tab-late-adjustments");
								}}
							>
								LATE ADJUSTMENTS
							</button>
						</div>
					)}
				</div>
				<div className="w-1/2 flex items-center justify-end">
					<div className="flex space-x-1">
						<Button
							icon={<NoteAddIcon />}
							name={"NEW"}
							className={"bg-cyan-500 hover:bg-cyan-600 border-none cursor-pointer"}
							onClick={addHandleClick}
						/>
						<Button
							icon={<DeleteSweepIcon />}
							name={"DELETE ALL"}
							className={"bg-red-500 hover:bg-red-600 border-none cursor-pointer"}
							onClick={deleteAllHandleClick}
						/>
					</div>
				</div>
			</div>
			<div className="payroll-tables">
				<div
					id="addition-table"
					className="payroll-table container"
					style={{ display: "block" }}
				>
					<CreateTable
						dataList={otherAdditionData}
						dataHeader={adjustmentsHeader}
						dataAccessor={adjustmentsAccesor}
						editHandleClick={editHandleClick}
						deleteHandleClick={deleteHandleClick}
						currentPage={currentPage_addition}
						setCurrentPage={setCurrentPage_addition}
					/>
					{otherAdditionData.length > 0 ? (
						<div></div>
					) : (
						<div>
							{loadingOtherAddition ? (
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "10vh",
									}}
								>
									<img src={loadingSpinner} alt="Loading..." />
								</div>
							) : (
								<div> {/*<p>No records to display</p>*/}</div>
							)}
						</div>
					)}
				</div>
				<div id="deduction-table" className="payroll-table container">
					<CreateTable
						dataList={otherDeductionData}
						dataHeader={adjustmentsHeader}
						dataAccessor={adjustmentsAccesor}
						editHandleClick={editHandleClick}
						deleteHandleClick={deleteHandleClick}
						currentPage={currentPage_deduction}
						setCurrentPage={setCurrentPage_deduction}
					/>
					{otherDeductionData.length > 0 ? (
						<div></div>
					) : (
						<div>
							{loadingOtherDedujction ? (
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "10vh",
									}}
								>
									<img src={loadingSpinner} alt="Loading..." />
								</div>
							) : (
								<div> {/*<p>No records to display</p>*/}</div>
							)}
						</div>
					)}
				</div>
				<div id="adjustment-table" className="payroll-table container">
					<div
						className="rightSide-btn"
						style={{ margin: "10px 5px", display: "none" }}
					>
						{CreateButton(
							"",
							"add row",
							handleGenerateLateApprovedAdjustments,
							"SYNC ADJUSTMENTS",
							SyncIcon
						)}
					</div>
					<CreateTable
						dataList={otherAdjustmentData}
						dataHeader={adjustmentsHeader}
						dataAccessor={adjustmentsAccesor}
						editHandleClick={editHandleClick}
						deleteHandleClick={deleteHandleClick}
						currentPage={currentPage_adjustment}
						setCurrentPage={setCurrentPage_adjustment}
					/>
					{otherAdjustmentData.length > 0 ? (
						<div></div>
					) : (
						<div>
							{loadingAdjustment ? (
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "10vh",
									}}
								>
									<img src={loadingSpinner} alt="Loading..." />
								</div>
							) : (
								<div> {/*<p>No records to display</p>*/}</div>
							)}
						</div>
					)}
				</div>
				<div id="late-adjustment-table" className="payroll-table container">
					<div className="rightSide-btn" style={{ margin: "10px 5px" }}>
						{CreateButton(
							"",
							"sync-adjustments add row",
							openLateAdjustmentForm,
							"SYNC ADJUSTMENTS",
							SyncIcon
						)}
					</div>

					<CreateTable
						dataList={otherLateAdjustmentData}
						dataHeader={lateAdjustmentsHeader}
						dataAccessor={lateAdjustmentsAccesor}
						editHandleClick={editHandleClick}
						deleteHandleClick={deleteHandleClick}
						currentPage={currentPage_lateAdjustment}
						setCurrentPage={setCurrentPage_lateAdjustment}
					/>
					{otherLateAdjustmentData.length > 0 ? (
						<div></div>
					) : (
						<div>
							{loadingLateAdjustment ? (
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "10vh",
									}}
								>
									<img src={loadingSpinner} alt="Loading..." />
								</div>
							) : (
								<div> {/*<p>No records to display</p>*/}</div>
							)}
						</div>
					)}
				</div>
			</div>
			<AddAdjustmentForm
				isOpen={showAddForm}
				onClose={closeAddHandleClick}
				employeePersonalInformationId={employeePersonalInformationId}
				employeePersonalInformationFullName={
					employeePersonalInformationFullName
				}
				payrollPeriodId={payrollPeriodId}
				payTypeId={payTypeId}
				payrollReasonCodeId={payrollReasonCodeId}
				amount={amount}
				noOfHours={noOfHours}
				adjustmentDate={adjustmentDate}
				reference={reference}
				referenceId={referenceId}
				setEployeePersonalInformationId={setEmployeePersonalInformationId}
				setPayrollPeriodId={setPayrollPeriodId}
				setPayTypeId={setPayTypeId}
				setPayrollReasonCodeId={setPayrollReasonCodeId}
				setAmount={setAmount}
				setNoOfHours={setNoOfHours}
				setAdjustmentDate={setAdjustmentDate}
				setReferenceId={setReferenceId}
				setShowEmployeeForm={setShowEmployeeForm}
				setReferenceIdForm={setReferenceIdForm}
				adjustmentType={adjustmentType}
				handleSubmit={handleSubmit}
			></AddAdjustmentForm>
			<EditAdjustmentForm
				isOpen={showEditForm}
				onClose={closeEditHandleClick}
				employeePersonalInformationId={employeePersonalInformationId}
				employeePersonalInformationFullName={
					employeePersonalInformationFullName
				}
				payrollPeriodId={payrollPeriodId}
				payTypeId={payTypeId}
				payrollReasonCodeId={payrollReasonCodeId}
				amount={amount}
				noOfHours={noOfHours}
				adjustmentDate={adjustmentDate}
				reference={reference}
				referenceId={referenceId}
				setEployeePersonalInformationId={setEmployeePersonalInformationId}
				setPayrollPeriodId={setPayrollPeriodId}
				setPayTypeId={setPayTypeId}
				setPayrollReasonCodeId={setPayrollReasonCodeId}
				setAmount={setAmount}
				setNoOfHours={setNoOfHours}
				setAdjustmentDate={setAdjustmentDate}
				setReferenceId={setReferenceId}
				setShowEmployeeForm={setShowEmployeeForm}
				setReferenceIdForm={setReferenceIdForm}
				adjustmentType={adjustmentType}
				handleUpdate={handleUpdate}
			></EditAdjustmentForm>
			<DeleteForm
				isOpen={showDeleteForm}
				onClose={closeDeleteHandleClick}
				handleDelete={handleDelete}
			></DeleteForm>
			<DeleteAllForm
				isOpen={showDeleteAllForm}
				onClose={closeDeleteAllHandleClick}
				payrollPeriodId={payrollIdForDelete}
				payTypeId={payTypeIdForDelete}
				setPayrollPeriodId={setPayrollIdForDelete}
				setPayTypeId={setPayTypeIdForDelete}
				handleDelete={handleDeleteAll}
			></DeleteAllForm>
			<EmployeeSelectForm
				isOpen={showEmployeeForm}
				onClose={closeEmployeeForm}
				setEmployeeId={setEmployeePersonalInformationId}
				setEmployee={setEmployeePersonalInformationFullName}
				userAccessData={userAccess}
				user={user}
			></EmployeeSelectForm>
			<ReferenceSelectForm
				isOpen={referenceIdForm}
				onClose={closeReferenceIdForm}
				setReference={setReference}
				setReferenceId={setReferenceId}
				setAdjustmentDate={setAdjustmentDate}
			></ReferenceSelectForm>
			<GenerateMessage
				form={showRequestMessage}
				message={isSuccess ? "Request Success!" : requestMessage}
				isSuccess={isSuccess}
			></GenerateMessage>
			{loadingRequest ? (
				<div
					style={{
						position: "fixed",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						zIndex: "3005",
					}}
				>
					<img src={loadingSpinner} alt="Loading..." />
				</div>
			) : (
				<></>
			)}
		</div>
	);
}